(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ab-featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (root._abFeaturedInit) return;
      var viewport = root.querySelector('.ab-featured__viewport');
      var track = root.querySelector('.ab-featured__track');
      if (!viewport || !track) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('.ab-featured__card'));
      if (!cards.length) return;
      var dotsWrap = root.querySelector('.ab-featured__dots');
      var prevBtn = root.querySelector('[data-ab-featured-prev]');
      var nextBtn = root.querySelector('[data-ab-featured-next]');
      var gap = 24;
      var cur = 0;
      var steps = 1;
      var cardW = 0;

      function measure() {
        var cs = getComputedStyle(viewport);
        var padL = parseFloat(cs.paddingLeft) || 0;
        var padR = parseFloat(cs.paddingRight) || 0;
        var content = viewport.clientWidth - padL - padR;
        cardW = cards[0].getBoundingClientRect().width;
        var vis = Math.max(1, Math.round((content + gap) / (cardW + gap)));
        steps = Math.max(1, cards.length - vis + 1);
        if (cur > steps - 1) cur = steps - 1;
      }

      function renderDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        for (var i = 0; i < steps; i++) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'ab-featured__dot' + (i === cur ? ' is-on' : '');
          d.setAttribute('aria-label', 'Aller à la vue ' + (i + 1));
          (function (j) {
            d.addEventListener('click', function () { go(j); });
          })(i);
          dotsWrap.appendChild(d);
        }
      }

      function go(idx) {
        cur = Math.max(0, Math.min(idx, steps - 1));
        track.style.transform = 'translateX(-' + (cur * (cardW + gap)) + 'px)';
        if (dotsWrap) {
          var dots = dotsWrap.children;
          for (var i = 0; i < dots.length; i++) {
            dots[i].classList.toggle('is-on', i === cur);
          }
        }
      }

      function reset() {
        measure();
        renderDots();
        go(cur);
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { go(cur - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(cur + 1); });

      /* Swipe tactile */
      var sx = 0, sy = 0, st = 0, active = false;
      viewport.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY;
        st = Date.now(); active = true;
      }, { passive: true });
      viewport.addEventListener('touchmove', function (e) {
        if (!active || e.touches.length !== 1) return;
        var dx = Math.abs(e.touches[0].clientX - sx);
        var dy = Math.abs(e.touches[0].clientY - sy);
        if (dy > dx && dy > 10) active = false;
      }, { passive: true });
      viewport.addEventListener('touchend', function (e) {
        if (!active) return;
        active = false;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        var dt = Date.now() - st;
        if (Math.abs(dx) < 40 || Math.abs(dy) > Math.abs(dx) || dt > 600) return;
        if (dx < 0) go(cur + 1); else go(cur - 1);
      }, { passive: true });

      root._abFeaturedInit = true;
      root._abFeaturedReset = reset;
      reset();
    }

    function initAll(ctx) {
      var roots = (ctx || document).querySelectorAll('.ab-featured[data-ab-carousel]');
      Array.prototype.forEach.call(roots, initCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        var roots = document.querySelectorAll('.ab-featured[data-ab-carousel]');
        Array.prototype.forEach.call(roots, function (r) {
          if (r._abFeaturedReset) r._abFeaturedReset();
        });
      }, 150);
    });

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
